"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f99 = void 0;
exports.f99 = {
    "ca": [
        "Latn"
    ],
    "caa": [
        "Latn"
    ],
    "cab": [
        "Latn"
    ],
    "cac": [
        "Latn"
    ],
    "cad": [
        "Latn"
    ],
    "cae": [
        "Latn"
    ],
    "caf": [
        "Latn",
        "Cans"
    ],
    "cag": [
        "Latn"
    ],
    "cah": [
        "Latn"
    ],
    "caj": [
        "Latn"
    ],
    "cak": [
        "Latn"
    ],
    "cal": [
        "Latn"
    ],
    "cam": [
        "Latn"
    ],
    "can": [
        "Latn"
    ],
    "cao": [
        "Latn"
    ],
    "cap": [
        "Latn"
    ],
    "caq": [
        "Latn"
    ],
    "car": [
        "Latn"
    ],
    "cas": [
        "Latn"
    ],
    "cav": [
        "Latn"
    ],
    "caw": [
        "Latn"
    ],
    "cax": [
        "Latn"
    ],
    "cay": [
        "Latn"
    ],
    "caz": [
        "Latn"
    ],
    "cbb": [
        "Latn"
    ],
    "cbc": [
        "Latn"
    ],
    "cbd": [
        "Latn"
    ],
    "cbg": [
        "Latn"
    ],
    "cbi": [
        "Latn"
    ],
    "cbj": [
        "Latn"
    ],
    "cbk": [
        "Latn",
        "Brai"
    ],
    "cbl": [
        "Latn"
    ],
    "cbn": [
        "Thai"
    ],
    "cbo": [
        "Latn"
    ],
    "cbq": [
        "Latn"
    ],
    "cbr": [
        "Latn"
    ],
    "cbs": [
        "Latn"
    ],
    "cbt": [
        "Latn"
    ],
    "cbu": [
        "Latn"
    ],
    "cbv": [
        "Latn"
    ],
    "cbw": [
        "Latn"
    ],
    "cby": [
        "Latn"
    ],
    "cca": [
        "Latn"
    ],
    "ccc": [
        "Latn"
    ],
    "ccd": [
        "Latn"
    ],
    "cce": [
        "Latn"
    ],
    "ccg": [
        "Latn"
    ],
    "cch": [
        "Latn"
    ],
    "ccj": [
        "Latn"
    ],
    "ccl": [
        "Latn"
    ],
    "ccm": [
        "Latn"
    ],
    "cco": [
        "Latn"
    ],
    "ccp": [
        "Cakm",
        "Beng",
        "Latn"
    ],
    "ccr": [
        "Latn"
    ],
    "cda": [
        "Zyyy"
    ],
    "cde": [
        "Telu"
    ],
    "cdf": [
        "Latn",
        "Beng"
    ],
    "cdg": [
        "Zyyy"
    ],
    "cdh": [
        "Deva",
        "Takr"
    ],
    "cdi": [
        "Gujr"
    ],
    "cdj": [
        "Deva"
    ],
    "cdm": [
        "Deva",
        "Latn"
    ],
    "cdn": [
        "Zyyy"
    ],
    "cdo": [
        "Hans",
        "Hant",
        "Latn"
    ],
    "cdr": [
        "Latn"
    ],
    "cds": [
        "Zxxx"
    ],
    "cdy": [
        "Zyyy"
    ],
    "cdz": [
        "Beng"
    ],
    "ce": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "cea": [
        "Zyyy"
    ],
    "ceb": [
        "Latn",
        "Brai"
    ],
    "ceg": [
        "Latn"
    ],
    "cek": [
        "Latn"
    ],
    "cen": [
        "Latn"
    ],
    "cet": [
        "Latn"
    ],
    "cey": [
        "Latn"
    ],
    "cfa": [
        "Latn"
    ],
    "cfd": [
        "Latn"
    ],
    "cfg": [
        "Latn"
    ],
    "cfm": [
        "Latn",
        "Beng"
    ],
    "cga": [
        "Latn"
    ],
    "cgc": [
        "Latn"
    ],
    "cgg": [
        "Latn"
    ],
    "cgk": [
        "Tibt"
    ],
    "ch": [
        "Latn"
    ],
    "chb": [
        "Latn"
    ],
    "chc": [
        "Zyyy"
    ],
    "chd": [
        "Latn"
    ],
    "chf": [
        "Latn"
    ],
    "chg": [
        "Arab"
    ],
    "chh": [
        "Latn"
    ],
    "chj": [
        "Latn"
    ],
    "chk": [
        "Latn"
    ],
    "chl": [
        "Latn"
    ],
    "chm": [
        "Cyrl",
        "Latn"
    ],
    "chn": [
        "Latn",
        "Dupl"
    ],
    "cho": [
        "Latn"
    ],
    "chp": [
        "Latn",
        "Cans"
    ],
    "chq": [
        "Latn"
    ],
    "chr": [
        "Cher",
        "Latn"
    ],
    "cht": [
        "Latn"
    ],
    "chw": [
        "Latn"
    ],
    "chx": [
        "Deva"
    ],
    "chy": [
        "Latn"
    ],
    "chz": [
        "Latn"
    ],
    "cia": [
        "Latn",
        "Arab",
        "Hang"
    ],
    "cib": [
        "Latn"
    ],
    "cic": [
        "Latn"
    ],
    "cid": [
        "Zyyy"
    ],
    "cie": [
        "Latn"
    ],
    "cih": [
        "Deva"
    ],
    "cik": [
        "Zyyy"
    ],
    "cim": [
        "Latn"
    ],
    "cin": [
        "Latn"
    ],
    "cip": [
        "Latn"
    ],
    "cir": [
        "Latn"
    ],
    "ciw": [
        "Latn",
        "Cans"
    ],
    "ciy": [
        "Latn"
    ],
    "cja": [
        "Arab",
        "Cham",
        "Latn"
    ],
    "cje": [
        "Latn"
    ],
    "cjh": [
        "Zyyy"
    ],
    "cji": [
        "Cyrl"
    ],
    "cjk": [
        "Latn"
    ],
    "cjm": [
        "Cham",
        "Arab",
        "Latn"
    ],
    "cjn": [
        "Latn"
    ],
    "cjo": [
        "Latn"
    ],
    "cjp": [
        "Latn"
    ],
    "cjs": [
        "Latn",
        "Cyrl"
    ],
    "cjv": [
        "Latn"
    ],
    "cjy": [
        "Hans",
        "Hant"
    ],
    "ckb": [
        "Arab",
        "Latn"
    ],
    "ckh": [
        "Zyyy"
    ],
    "ckl": [
        "Latn"
    ],
    "ckm": [
        "Latn",
        "Glag"
    ],
    "ckn": [
        "Latn"
    ],
    "cko": [
        "Latn"
    ],
    "ckq": [
        "Latn"
    ],
    "ckr": [
        "Latn"
    ],
    "cks": [
        "Latn"
    ],
    "ckt": [
        "Cyrl"
    ],
    "cku": [
        "Latn"
    ],
    "ckv": [
        "Latn"
    ],
    "ckx": [
        "Latn"
    ],
    "cky": [
        "Latn"
    ],
    "ckz": [
        "Latn"
    ],
    "cla": [
        "Latn"
    ],
    "clc": [
        "Latn"
    ],
    "cle": [
        "Latn"
    ],
    "clh": [
        "Arab"
    ],
    "cli": [
        "Latn"
    ],
    "clj": [
        "Latn"
    ],
    "clk": [
        "Latn",
        "Tibt"
    ],
    "cll": [
        "Latn"
    ],
    "clm": [
        "Latn"
    ],
    "clo": [
        "Latn"
    ],
    "clt": [
        "Latn"
    ],
    "clu": [
        "Latn"
    ],
    "clw": [
        "Cyrl"
    ],
    "cly": [
        "Latn"
    ],
    "cma": [
        "Latn"
    ],
    "cme": [
        "Latn"
    ],
    "cmg": [
        "Soyo"
    ],
    "cmi": [
        "Latn"
    ],
    "cml": [
        "Latn"
    ],
    "cmm": [
        "Zyyy"
    ],
    "cmo": [
        "Khmr",
        "Latn"
    ],
    "cmr": [
        "Latn"
    ],
    "cms": [
        "Latn"
    ],
    "cmt": [
        "Latn"
    ],
    "cna": [
        "Tibt"
    ],
    "cnb": [
        "Latn"
    ],
    "cnc": [
        "Latn"
    ],
    "cng": [
        "Latn"
    ],
    "cnh": [
        "Latn"
    ],
    "cni": [
        "Latn"
    ],
    "cnk": [
        "Latn"
    ],
    "cnl": [
        "Latn"
    ],
    "cno": [
        "Zyyy"
    ],
    "cnp": [
        "Hans",
        "Hant"
    ],
    "cnr": [
        "Cyrl",
        "Latn"
    ],
    "cns": [
        "Latn"
    ],
    "cnt": [
        "Latn"
    ],
    "cnu": [
        "Zyyy"
    ],
    "cnw": [
        "Latn"
    ],
    "cnx": [
        "Latn"
    ],
    "co": [
        "Latn"
    ],
    "coa": [
        "Latn"
    ],
    "cob": [
        "Latn"
    ],
    "coc": [
        "Latn"
    ],
    "cod": [
        "Latn"
    ],
    "coe": [
        "Latn"
    ],
    "cof": [
        "Latn"
    ],
    "cog": [
        "Thai"
    ],
    "coh": [
        "Latn"
    ],
    "coj": [
        "Latn"
    ],
    "cok": [
        "Latn"
    ],
    "col": [
        "Latn"
    ],
    "com": [
        "Latn"
    ],
    "con": [
        "Latn"
    ],
    "coo": [
        "Latn"
    ],
    "cop": [
        "Copt",
        "Arab",
        "Grek"
    ],
    "coq": [
        "Zyyy"
    ],
    "cot": [
        "Latn"
    ],
    "cou": [
        "Latn"
    ],
    "cov": [
        "Zyyy"
    ],
    "cow": [
        "Zyyy"
    ],
    "cox": [
        "Latn"
    ],
    "coz": [
        "Latn"
    ],
    "cpa": [
        "Latn"
    ],
    "cpb": [
        "Latn"
    ],
    "cpc": [
        "Latn"
    ],
    "cpg": [
        "Grek"
    ],
    "cpi": [
        "Latn"
    ],
    "cpn": [
        "Latn"
    ],
    "cpo": [
        "Latn"
    ],
    "cps": [
        "Latn"
    ],
    "cpu": [
        "Latn"
    ],
    "cpx": [
        "Latn"
    ],
    "cpy": [
        "Latn"
    ],
    "cqd": [
        "Latn"
    ],
    "cr": [
        "Cans",
        "Latn"
    ],
    "cra": [
        "Zyyy"
    ],
    "crb": [
        "Latn"
    ],
    "crc": [
        "Latn"
    ],
    "crd": [
        "Latn"
    ],
    "crf": [
        "Latn"
    ],
    "crg": [
        "Latn"
    ],
    "crh": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "cri": [
        "Latn"
    ],
    "crj": [
        "Cans",
        "Latn"
    ],
    "crk": [
        "Cans",
        "Latn"
    ],
    "crl": [
        "Cans",
        "Latn"
    ],
    "crm": [
        "Cans"
    ],
    "crn": [
        "Latn"
    ],
    "cro": [
        "Latn"
    ],
    "crq": [
        "Latn"
    ],
    "crr": [
        "Zyyy"
    ],
    "crs": [
        "Latn"
    ],
    "crt": [
        "Latn"
    ],
    "crv": [
        "Zyyy"
    ],
    "crw": [
        "Latn"
    ],
    "crx": [
        "Latn",
        "Cans"
    ],
    "cry": [
        "Latn"
    ],
    "crz": [
        "Zyyy"
    ],
    "cs": [
        "Latn",
        "Brai"
    ],
    "csa": [
        "Latn"
    ],
    "csb": [
        "Latn"
    ],
    "csc": [
        "Zxxx"
    ],
    "csd": [
        "Zxxx"
    ],
    "cse": [
        "Zxxx"
    ],
    "csf": [
        "Zxxx"
    ],
    "csg": [
        "Zxxx"
    ],
    "csh": [
        "Mymr",
        "Latn"
    ],
    "csi": [
        "Zyyy"
    ],
    "csj": [
        "Latn"
    ],
    "csk": [
        "Latn"
    ],
    "csl": [
        "Zxxx"
    ],
    "csm": [
        "Latn"
    ],
    "csn": [
        "Zxxx"
    ],
    "cso": [
        "Latn"
    ],
    "csp": [
        "Hans",
        "Hant"
    ],
    "csq": [
        "Zxxx"
    ],
    "csr": [
        "Zxxx"
    ],
    "css": [
        "Zyyy"
    ],
    "cst": [
        "Latn"
    ],
    "csv": [
        "Latn"
    ],
    "csw": [
        "Cans"
    ],
    "csx": [
        "Zxxx"
    ],
    "csy": [
        "Latn"
    ],
    "csz": [
        "Latn"
    ],
    "cta": [
        "Latn"
    ],
    "ctc": [
        "Latn"
    ],
    "ctd": [
        "Pauc",
        "Latn"
    ],
    "cte": [
        "Latn"
    ],
    "ctg": [
        "Beng",
        "Arab",
        "Latn"
    ],
    "cth": [
        "Latn"
    ],
    "ctl": [
        "Latn"
    ],
    "ctm": [
        "Zyyy"
    ],
    "ctn": [
        "Deva"
    ],
    "cto": [
        "Latn"
    ],
    "ctp": [
        "Latn"
    ],
    "cts": [
        "Latn"
    ],
    "ctt": [
        "Taml"
    ],
    "ctu": [
        "Latn"
    ],
    "cty": [
        "Zyyy"
    ],
    "ctz": [
        "Latn"
    ],
    "cu": [
        "Cyrl",
        "Cyrs",
        "Glag"
    ],
    "cua": [
        "Latn"
    ],
    "cub": [
        "Latn"
    ],
    "cuc": [
        "Latn"
    ],
    "cug": [
        "Latn"
    ],
    "cuh": [
        "Latn"
    ],
    "cui": [
        "Latn"
    ],
    "cuj": [
        "Latn"
    ],
    "cuk": [
        "Latn"
    ],
    "cul": [
        "Latn"
    ],
    "cuo": [
        "Latn"
    ],
    "cup": [
        "Zyyy"
    ],
    "cuq": [
        "Zyyy"
    ],
    "cur": [
        "Zyyy"
    ],
    "cut": [
        "Latn"
    ],
    "cuu": [
        "Lana"
    ],
    "cuv": [
        "Latn"
    ],
    "cuw": [
        "Zyyy"
    ],
    "cux": [
        "Latn"
    ],
    "cuy": [
        "Latn"
    ],
    "cv": [
        "Cyrl"
    ],
    "cvg": [
        "Latn",
        "Tibt"
    ],
    "cvn": [
        "Latn"
    ],
    "cwa": [
        "Latn"
    ],
    "cwb": [
        "Latn"
    ],
    "cwe": [
        "Latn"
    ],
    "cwg": [
        "Latn"
    ],
    "cwt": [
        "Latn"
    ],
    "cy": [
        "Latn",
        "Brai"
    ],
    "cya": [
        "Latn"
    ],
    "cyb": [
        "Latn"
    ],
    "cyo": [
        "Latn"
    ],
    "czh": [
        "Hans",
        "Hant"
    ],
    "czk": [
        "Zyyy"
    ],
    "czn": [
        "Latn"
    ],
    "czo": [
        "Zyyy"
    ],
    "czt": [
        "Latn"
    ]
};
